import { TournamentBracketMatchGameResultReason as ResultReason } from '@okletsplay/core';

export const BRACKET_RESULT_REASON_LABEL: Record<ResultReason, string> = {
  [ResultReason.Disqualification]: 'Team disqualification',
  [ResultReason.GameResults]: 'Score based on gameplay results',
  [ResultReason.JoinGameTimeout]: 'Team did not join in time',
  [ResultReason.ManualScoreAssignment]: 'Score assigned by Admin',
};
